import { render, staticRenderFns } from "./ShaimZboziCz.vue?vue&type=template&id=2a389bc4&"
import script from "./ShaimZboziCz.vue?vue&type=script&lang=js&"
export * from "./ShaimZboziCz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports